
export const RELOAD_PAGE = 'RELOAD_PAGE';
export const RESTORE_ACCESS_TOKEN = 'RESTORE_ACCESS_TOKEN';
export const SET_ACTIVE_MENU_ITEM = 'SET_ACTIVE_MENU_ITEM';
export const OPEN_FORM = 'OPEN_FORM';
export const CLOSE_FORM = 'CLOSE_FORM';


